export default __webpack_public_path__ + "public/images/errors/broken-developer-logo.png?794f161b";